import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { prefetchDNS, preconnect } from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App.tsx';
import './i18n/config';
import './index.css';

// Asset preloading — speed up initial connections
preconnect('https://firebaseauth.googleapis.com', { crossOrigin: 'anonymous' });
preconnect('https://firestore.googleapis.com', { crossOrigin: 'anonymous' });
prefetchDNS('https://sentry.io');

Sentry.init({
  dsn: 'https://a740cf45202c11213fc2de5103d234ff@o4510940497182720.ingest.de.sentry.io/4511702107750480',
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});

const FallbackUI = () => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'system-ui, sans-serif' }}>
    <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '0.5rem' }}>Something went wrong</h1>
    <p style={{ color: '#6b7280', marginBottom: '1rem' }}>An unexpected error occurred.</p>
    <button
      onClick={() => window.location.reload()}
      style={{ padding: '0.5rem 1rem', backgroundColor: '#2563eb', color: '#fff', border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontSize: '0.875rem' }}
    >
      Try Again
    </button>
  </div>
);

createRoot(document.getElementById('root')!, {
  onCaughtError(error, errorInfo) {
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo.componentStack },
    });
  },
  onUncaughtError(error, errorInfo) {
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo.componentStack },
      level: 'fatal',
    });
  },
}).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
